import dayjs from "dayjs";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";
import { useMemo, useState, useEffect } from "react";
import { useCompConfig } from "@/context/CompConfigContext";
import useBangKeoMatches from "@/hooks/useBangKeoMatches";
import StakeLoading from "@/components/StakeLoading";
import NoData from "@/components/NoData";
import AfinaMatchLeagues from "../AfinaMatchLeagues";
import AfinaMatch from "../AfinaMatch";
import AfinaDateTabs from "../AfinaDateTabs";
import { BANG_KEO_PAGE_LIMIT } from "@/contants";
import { useLiveData } from "@/hooks/useLiveData";
import { useLiveUpdates } from "@/hooks/useLiveUpdates";

dayjs.extend(utc);
dayjs.extend(timezone);

const TZ = "Asia/Ho_Chi_Minh";

const KbvTiLeV5 = ({ type = "all" }) => {
  const {
    colorPrimary,
    colorSecondary,
    colorBg,
    colorText,
    colorForeground,
    hasDataConfig,
  } = useCompConfig();
  const [firstLoad, setFirstLoad] = useState(true);
  const today = dayjs().tz(TZ);
  const todayString = today.format("YYYY-MM-DD");
  const [selectedDate, setSelectedDate] = useState(todayString);

  const dateString =
    !selectedDate || selectedDate === ""
      ? "all"
      : selectedDate === "live"
        ? todayString
        : selectedDate;
  const status =
    type === "ketqua" ? "end" : selectedDate === "live" ? "live" : "";

  const queryObject = useMemo(
    () => ({
      include: "homeTeam,awayTeam,odd,countOtherOdds,stats,events,insight",
      filterInclude: `date:${dateString}`,
      filterOdds: -1,
      cache: false,
      status,
      page: 1,
      limit: BANG_KEO_PAGE_LIMIT,
    }),
    [dateString, status],
  );

  const {
    leaguesWithMatches,
    loading,
    hasMore,
    loadMoreRef,
    isLoadingMoreRef,
  } = useBangKeoMatches(queryObject);

  const filteredLeaguesWithMatches = useMemo(
    () => leaguesWithMatches || [],
    [leaguesWithMatches],
  );

  const matchIds = useMemo(
    () =>
      filteredLeaguesWithMatches.flatMap(
        (league) => league.matches?.map((match) => match.id) || [],
      ),
    [filteredLeaguesWithMatches],
  );

  const { clearAllData } = useLiveData();

  useLiveUpdates(matchIds);

  useEffect(() => {
    return () => {
      clearAllData();
    };
  }, [clearAllData]);

  useEffect(() => {
    if (
      firstLoad &&
      selectedDate === "live" &&
      !loading &&
      filteredLeaguesWithMatches.length <= 0
    ) {
      setSelectedDate(todayString);
    }
  }, [
    firstLoad,
    selectedDate,
    loading,
    filteredLeaguesWithMatches,
    todayString,
  ]);

  const themeStyle = hasDataConfig
    ? {
        "--theme-primary": colorPrimary,
        "--theme-highlight": colorSecondary,
        "--theme-bg": colorBg,
        "--theme-text": colorText,
        "--theme-foreground": colorForeground,
      }
    : undefined;

  const handleDateChange = (value) => {
    setSelectedDate(value);
    setFirstLoad(false);
  };

  return (
    <div
      className="mx-auto rounded-xl flex flex-col gap-3 min-h-screen"
      style={themeStyle}
    >
      <AfinaDateTabs
        selectedDate={selectedDate}
        onDateChange={handleDateChange}
      />

      {/* {loading && <StakeLoading />} */}
      {!loading && (
        <>
          <div className="space-y-2 rounded-lg ">
            {filteredLeaguesWithMatches.length === 0 ? (
              <NoData message="Không có trận đấu nào" />
            ) : (
              filteredLeaguesWithMatches.map(({ league, matches }) => (
                <AfinaMatchLeagues
                  key={league.id}
                  league={league}
                  matches={matches}
                />
              ))
            )}
          </div>
          {hasMore && (
            <div ref={loadMoreRef} className="py-4 text-center">
              {isLoadingMoreRef && <StakeLoading />}
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default KbvTiLeV5;
